export const sanitizeOnlyNumbers = (value: string) =>
  value.replace(/\.|-|\/|\(|\)|\s/g, '');
